var _desc, _path, _path2, _ellipse, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeafood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Seafood") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M56.35 25.418c.33 4.916-2.16 14.242-7.207 19.035-2.346-5.166-7.509-7.295-7.048-7.193m-5.81-29.105c-11.428 0-20 8.713-20 8.713s9.834.9 10.117 4.434",
    "data-name": "layer2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M39.969 6.1a28 28 0 0 0-8.978 7.83c-7.094 9.508-10.432 21.324-12.733 31.8A122.8 122.8 0 0 0 42 37.194c6.875-3.377 11.381-7.461 14.344-11.777M14.738 62c1.179-4.473 2.172-10.143 3.518-16.271A125.052 125.052 0 0 1 2 48.809S13.145 52.457 14.738 62z",
    "data-name": "layer2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    ry: 2.054,
    rx: 2.021,
    cy: 11.685,
    cx: 51.878,
    "data-name": "layer1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M39.969 6.1c0 9.629 4.914 17.547 16.375 19.316C61.754 17.536 62 8.881 62 2.348c0 0-11.561-2.033-22.031 3.752z",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeafood);
export default __webpack_public_path__ + "static/media/seafood.0b6d258a.svg";
export { ForwardRef as ReactComponent };